import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import Checkbox from '../../../../../../components/Checkbox';

import { Label } from './styles';
import { Input, CheckboxLabel } from '../../../../../../assets/styles';

class Inputs extends Component {
  state = {
    mondayStartFocus: false,
    mondayEndFocus: false,
    tuesdayStartFocus: false,
    tuesdayEndFocus: false,
    wednesdayStartFocus: false,
    wednesdayEndFocus: false,
    thursdayStartFocus: false,
    thursdayEndFocus: false,
    fridayStartFocus: false,
    fridayEndFocus: false,
    saturdayStartFocus: false,
    saturdayEndFocus: false,
    sundayStartFocus: false,
    sundayEndFocus: false,
  }

  handleOpeningHours = (day, start, end) => {
    this.props.handleOpeningHoursChange(day, { start, end, closed: false });
  }

  handleClosedDay = (day, closed) => {
    if (closed) {
      this.props.handleOpeningHoursChange(day, { start: '', end: '', closed: false });
    } else {
      this.props.handleOpeningHoursChange(day, { start: '', end: '', closed: true });
    }
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      mondayStartFocus,
      mondayEndFocus,
      tuesdayStartFocus,
      tuesdayEndFocus,
      wednesdayStartFocus,
      wednesdayEndFocus,
      thursdayStartFocus,
      thursdayEndFocus,
      fridayStartFocus,
      fridayEndFocus,
      saturdayStartFocus,
      saturdayEndFocus,
      sundayStartFocus,
      sundayEndFocus,
    } = this.state;

    const {
      openingHours,
      mondayError,
      tuesdayError,
      wednesdayError,
      thursdayError,
      fridayError,
      saturdayError,
      sundayError,
    } = this.props.state;

    return (
      <div>
        <div className="row-2 opening-hours">
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="days">Segunda-feira</p>
              </Label>
              <Label>
                <p className="fieldName">Horário inicial</p>
                <InputMask
                  readOnly={openingHours.monday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.monday.start}
                  onFocusInput={mondayStartFocus}
                  onChange={e => this.handleOpeningHours('monday', e.target.value, openingHours.monday.end)}
                  onFocus={() => !openingHours.monday.closed && this.onFocus('mondayStartFocus')}
                  onBlur={() => !openingHours.monday.closed && this.onBlur('mondayStartFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={mondayError}
                    />
                  )}
                </InputMask>
              </Label>
            </div>
          </Label>
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="fieldName">Horário final</p>
                <InputMask
                  readOnly={openingHours.monday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.monday.end}
                  onFocusInput={mondayEndFocus}
                  onChange={e => this.handleOpeningHours('monday', openingHours.monday.start, e.target.value)}
                  onFocus={() => !openingHours.monday.closed && this.onFocus('mondayEndFocus')}
                  onBlur={() => !openingHours.monday.closed && this.onBlur('mondayEndFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={mondayError}
                    />
                  )}
                </InputMask>
              </Label>
              <Label>
                <CheckboxLabel className="checkbox">
                  <Checkbox
                    name="closed"
                    checked={openingHours.monday.closed}
                    onChange={() => this.handleClosedDay('monday', openingHours.monday.closed)}
                  />
                  <span>Fechado</span>
                </CheckboxLabel>
              </Label>
            </div>
          </Label>
        </div>
        <div className="row-2 opening-hours">
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="days">Terça-feira</p>
              </Label>
              <Label>
                <p className="fieldName">Horário inicial</p>
                <InputMask
                  readOnly={openingHours.tuesday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.tuesday.start}
                  onFocusInput={tuesdayStartFocus}
                  onChange={e => this.handleOpeningHours('tuesday', e.target.value, openingHours.tuesday.end)}
                  onFocus={() => !openingHours.tuesday.closed && this.onFocus('tuesdayStartFocus')}
                  onBlur={() => !openingHours.tuesday.closed && this.onBlur('tuesdayStartFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={tuesdayError}
                    />
                  )}
                </InputMask>
              </Label>
            </div>
          </Label>
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="fieldName">Horário final</p>
                <InputMask
                  readOnly={openingHours.tuesday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.tuesday.end}
                  onFocusInput={tuesdayEndFocus}
                  onChange={e => this.handleOpeningHours('tuesday', openingHours.tuesday.start, e.target.value)}
                  onFocus={() => !openingHours.tuesday.closed && this.onFocus('tuesdayEndFocus')}
                  onBlur={() => !openingHours.tuesday.closed && this.onBlur('tuesdayEndFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={tuesdayError}
                    />
                  )}
                </InputMask>
              </Label>
              <Label>
                <CheckboxLabel className="checkbox">
                  <Checkbox
                    name="closed"
                    checked={openingHours.tuesday.closed}
                    onChange={() => this.handleClosedDay('tuesday', openingHours.tuesday.closed)}
                  />
                  <span>Fechado</span>
                </CheckboxLabel>
              </Label>
            </div>
          </Label>
        </div>
        <div className="row-2 opening-hours">
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="days">Quarta-feira</p>
              </Label>
              <Label>
                <p className="fieldName">Horário inicial</p>
                <InputMask
                  readOnly={openingHours.wednesday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.wednesday.start}
                  onFocusInput={wednesdayStartFocus}
                  onChange={e => this.handleOpeningHours('wednesday', e.target.value, openingHours.wednesday.end)}
                  onFocus={() => !openingHours.wednesday.closed && this.onFocus('wednesdayStartFocus')}
                  onBlur={() => !openingHours.wednesday.closed && this.onBlur('wednesdayStartFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={wednesdayError}
                    />
                  )}
                </InputMask>
              </Label>
            </div>
          </Label>
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="fieldName">Horário final</p>
                <InputMask
                  readOnly={openingHours.wednesday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.wednesday.end}
                  onFocusInput={wednesdayEndFocus}
                  onChange={e => this.handleOpeningHours('wednesday', openingHours.wednesday.start, e.target.value)}
                  onFocus={() => !openingHours.wednesday.closed && this.onFocus('wednesdayEndFocus')}
                  onBlur={() => !openingHours.wednesday.closed && this.onBlur('wednesdayEndFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={wednesdayError}
                    />
                  )}
                </InputMask>
              </Label>
              <Label>
                <CheckboxLabel className="checkbox">
                  <Checkbox
                    name="closed"
                    checked={openingHours.wednesday.closed}
                    onChange={() => this.handleClosedDay('wednesday', openingHours.wednesday.closed)}
                  />
                  <span>Fechado</span>
                </CheckboxLabel>
              </Label>
            </div>
          </Label>
        </div>
        <div className="row-2 opening-hours">
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="days">Quinta-feira</p>
              </Label>
              <Label>
                <p className="fieldName">Horário inicial</p>
                <InputMask
                  readOnly={openingHours.thursday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.thursday.start}
                  onFocusInput={thursdayStartFocus}
                  onChange={e => this.handleOpeningHours('thursday', e.target.value, openingHours.thursday.end)}
                  onFocus={() => !openingHours.thursday.closed && this.onFocus('thursdayStartFocus')}
                  onBlur={() => !openingHours.thursday.closed && this.onBlur('thursdayStartFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={thursdayError}
                    />
                  )}
                </InputMask>
              </Label>
            </div>
          </Label>
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="fieldName">Horário final</p>
                <InputMask
                  readOnly={openingHours.thursday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.thursday.end}
                  onFocusInput={thursdayEndFocus}
                  onChange={e => this.handleOpeningHours('thursday', openingHours.thursday.start, e.target.value)}
                  onFocus={() => !openingHours.thursday.closed && this.onFocus('thursdayEndFocus')}
                  onBlur={() => !openingHours.thursday.closed && this.onBlur('thursdayEndFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={thursdayError}
                    />
                  )}
                </InputMask>
              </Label>
              <Label>
                <CheckboxLabel className="checkbox">
                  <Checkbox
                    name="closed"
                    checked={openingHours.thursday.closed}
                    onChange={() => this.handleClosedDay('thursday', openingHours.thursday.closed)}
                  />
                  <span>Fechado</span>
                </CheckboxLabel>
              </Label>
            </div>
          </Label>
        </div>
        <div className="row-2 opening-hours">
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="days">Sexta-feira</p>
              </Label>
              <Label>
                <p className="fieldName">Horário inicial</p>
                <InputMask
                  readOnly={openingHours.friday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.friday.start}
                  onFocusInput={fridayStartFocus}
                  onChange={e => this.handleOpeningHours('friday', e.target.value, openingHours.friday.end)}
                  onFocus={() => !openingHours.friday.closed && this.onFocus('fridayStartFocus')}
                  onBlur={() => !openingHours.friday.closed && this.onBlur('fridayStartFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={fridayError}
                    />
                  )}
                </InputMask>
              </Label>
            </div>
          </Label>
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="fieldName">Horário final</p>
                <InputMask
                  readOnly={openingHours.friday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.friday.end}
                  onFocusInput={fridayEndFocus}
                  onChange={e => this.handleOpeningHours('friday', openingHours.friday.start, e.target.value)}
                  onFocus={() => !openingHours.friday.closed && this.onFocus('fridayEndFocus')}
                  onBlur={() => !openingHours.friday.closed && this.onBlur('fridayEndFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={fridayError}
                    />
                  )}
                </InputMask>
              </Label>
              <Label>
                <CheckboxLabel className="checkbox">
                  <Checkbox
                    name="closed"
                    checked={openingHours.friday.closed}
                    onChange={() => this.handleClosedDay('friday', openingHours.friday.closed)}
                  />
                  <span>Fechado</span>
                </CheckboxLabel>
              </Label>
            </div>
          </Label>
        </div>
        <div className="row-2 opening-hours">
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="days">Sábado</p>
              </Label>
              <Label>
                <p className="fieldName">Horário inicial</p>
                <InputMask
                  readOnly={openingHours.saturday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.saturday.start}
                  onFocusInput={saturdayStartFocus}
                  onChange={e => this.handleOpeningHours('saturday', e.target.value, openingHours.saturday.end)}
                  onFocus={() => !openingHours.saturday.closed && this.onFocus('saturdayStartFocus')}
                  onBlur={() => !openingHours.saturday.closed && this.onBlur('saturdayStartFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={saturdayError}
                    />
                  )}
                </InputMask>
              </Label>
            </div>
          </Label>
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="fieldName">Horário final</p>
                <InputMask
                  readOnly={openingHours.saturday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.saturday.end}
                  onFocusInput={saturdayEndFocus}
                  onChange={e => this.handleOpeningHours('saturday', openingHours.saturday.start, e.target.value)}
                  onFocus={() => !openingHours.saturday.closed && this.onFocus('saturdayEndFocus')}
                  onBlur={() => !openingHours.saturday.closed && this.onBlur('saturdayEndFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={saturdayError}
                    />
                  )}
                </InputMask>
              </Label>
              <Label>
                <CheckboxLabel className="checkbox">
                  <Checkbox
                    name="closed"
                    checked={openingHours.saturday.closed}
                    onChange={() => this.handleClosedDay('saturday', openingHours.saturday.closed)}
                  />
                  <span>Fechado</span>
                </CheckboxLabel>
              </Label>
            </div>
          </Label>
        </div>
        <div className="row-2 opening-hours">
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="days">Domingo</p>
              </Label>
              <Label>
                <p className="fieldName">Horário inicial</p>
                <InputMask
                  readOnly={openingHours.sunday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.sunday.start}
                  onFocusInput={sundayStartFocus}
                  onChange={e => this.handleOpeningHours('sunday', e.target.value, openingHours.sunday.end)}
                  onFocus={() => !openingHours.sunday.closed && this.onFocus('sundayStartFocus')}
                  onBlur={() => !openingHours.sunday.closed && this.onBlur('sundayStartFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={sundayError}
                    />
                  )}
                </InputMask>
              </Label>
            </div>
          </Label>
          <Label style={{ marginBottom: 0 }}>
            <div className="row-2-2 opening-hours">
              <Label>
                <p className="fieldName">Horário final</p>
                <InputMask
                  readOnly={openingHours.sunday.closed}
                  mask="99:99"
                  maskChar={null}
                  value={openingHours.sunday.end}
                  onFocusInput={sundayEndFocus}
                  onChange={e => this.handleOpeningHours('sunday', openingHours.sunday.start, e.target.value)}
                  onFocus={() => !openingHours.sunday.closed && this.onFocus('sundayEndFocus')}
                  onBlur={() => !openingHours.sunday.closed && this.onBlur('sundayEndFocus')}
                >
                  {inputProps => (
                    <Input
                      {...inputProps}
                      type="text"
                      placeholder="00:00"
                      size="10"
                      error={sundayError}
                    />
                  )}
                </InputMask>
              </Label>
              <Label>
                <CheckboxLabel className="checkbox" style={{ paddingBottom: 0 }}>
                  <Checkbox
                    name="closed"
                    checked={openingHours.sunday.closed}
                    onChange={() => this.handleClosedDay('sunday', openingHours.sunday.closed)}
                  />
                  <span>Fechado</span>
                </CheckboxLabel>
              </Label>
            </div>
          </Label>
        </div>
      </div>
    );
  }
}

export default Inputs;
